import React, { useState, useMemo } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const inputStyle = {
  padding: "8px 12px",
  border: `1px solid #e2e8f0`,
  borderRadius: "6px",
  fontSize: "14px",
  width: "100%",
  maxWidth: "100%",
};

const inputFocusStyle = { borderColor: teal, outline: "none" };

function formatDateForDisplay(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export default function CreateAMCBill() {
  const [chooseType, setChooseType] = useState("creditNote"); // "amcBill" | "creditNote"
  const [fund, setFund] = useState("Abakkus Mutual Fund");
  const [billingName, setBillingName] = useState("Abakkus Mutual Fund");
  const [address1, setAddress1] = useState("6th Floor, Param House, Shanti Nagar");
  const [city, setCity] = useState("Mumbai");
  const [pan, setPan] = useState("AALTA6839J");
  const [creditNoteNo, setCreditNoteNo] = useState("");
  const [arn, setArn] = useState("ARN-315999");
  const [gstin, setGstin] = useState("27AALTA6839J1Z6");
  const [address2, setAddress2] = useState("Near Hyatt, Santacruz (East), Mumbai");
  const [pin, setPin] = useState("400055");
  const [cin, setCin] = useState("U66301MH2025PTC446708");
  const [partyRefNo, setPartyRefNo] = useState("");
  const [creditNoteDate, setCreditNoteDate] = useState("2026-02-16");
  const [sac, setSac] = useState("");
  const [address3, setAddress3] = useState("");
  const [state, setState] = useState("Maharashtra");
  const [phone, setPhone] = useState("");
  const [grossCommission, setGrossCommission] = useState("");
  const [billingFrom, setBillingFrom] = useState("2026-01-01");
  const [billingTo, setBillingTo] = useState("2026-01-31");
  const [cgstPct, setCgstPct] = useState("0");
  const [sgstPct, setSgstPct] = useState("0");
  const [igstPct, setIgstPct] = useState("0");
  const [signatoryName, setSignatoryName] = useState("");

  const billDescription = useMemo(() => {
    const from = formatDateForDisplay(billingFrom);
    const to = formatDateForDisplay(billingTo);
    return from && to ? `Distribution Commission for sale of Mutual Fund for the period ${from} to ${to}` : "";
  }, [billingFrom, billingTo]);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Create AMC Bill</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/billing/create-client-bill">Billing</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Create AMC Bill
                </li>
              </ol>
            </nav>
          </div>

          <div style={cardStyle}>
            {/* Choose */}
            <div className="mb-4">
              <label className="form-label mb-2 d-block" style={{ fontSize: "14px", color: "#334155" }}>Choose :</label>
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name="chooseType"
                    checked={chooseType === "amcBill"}
                    onChange={() => setChooseType("amcBill")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  AMC Bill
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name="chooseType"
                    checked={chooseType === "creditNote"}
                    onChange={() => setChooseType("creditNote")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  Credit Note
                </label>
              </div>
            </div>

            {/* Three-column form */}
            <div className="row g-3 mb-4">
              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Fund</label>
                  <select value={fund} onChange={(e) => setFund(e.target.value)} style={inputStyle} onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)} onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}>
                    <option value="Abakkus Mutual Fund">Abakkus Mutual Fund</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Billing Name</label>
                  <input type="text" value={billingName} onChange={(e) => setBillingName(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Address 1</label>
                  <input type="text" value={address1} onChange={(e) => setAddress1(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>City</label>
                  <input type="text" value={city} onChange={(e) => setCity(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>PAN</label>
                  <input type="text" value={pan} onChange={(e) => setPan(e.target.value)} style={inputStyle} />
                </div>
                {chooseType === "creditNote" && (
                  <div className="mb-3">
                    <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Credit Note No</label>
                    <input type="text" value={creditNoteNo} onChange={(e) => setCreditNoteNo(e.target.value)} style={inputStyle} placeholder="" />
                  </div>
                )}
              </div>
              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>ARN</label>
                  <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle} onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)} onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}>
                    <option value="ARN-315999">ARN-315999</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>GSTIN</label>
                  <input type="text" value={gstin} onChange={(e) => setGstin(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Address 2</label>
                  <input type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Pin</label>
                  <input type="text" value={pin} onChange={(e) => setPin(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>CIN</label>
                  <input type="text" value={cin} onChange={(e) => setCin(e.target.value)} style={inputStyle} />
                </div>
                {chooseType === "creditNote" && (
                  <div className="mb-3">
                    <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Party Reference no.</label>
                    <input type="text" value={partyRefNo} onChange={(e) => setPartyRefNo(e.target.value)} style={inputStyle} />
                  </div>
                )}
              </div>
              <div className="col-12 col-md-4">
                {chooseType === "creditNote" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Credit Note Date</label>
                      <input type="date" value={creditNoteDate} onChange={(e) => setCreditNoteDate(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>SAC</label>
                      <input type="text" value={sac} onChange={(e) => setSac(e.target.value)} style={inputStyle} />
                    </div>
                  </>
                )}
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Address 3</label>
                  <input type="text" value={address3} onChange={(e) => setAddress3(e.target.value)} style={inputStyle} />
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>State</label>
                  <select value={state} onChange={(e) => setState(e.target.value)} style={inputStyle} onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)} onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}>
                    <option value="Maharashtra">Maharashtra</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Phone</label>
                  <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} style={inputStyle} />
                </div>
                {chooseType === "creditNote" && (
                  <div className="mb-3">
                    <label className="form-label mb-1" style={{ fontSize: "13px", color: "#64748b" }}>Gross Commission Received (Rs)</label>
                    <input type="text" value={grossCommission} onChange={(e) => setGrossCommission(e.target.value)} style={inputStyle} />
                  </div>
                )}
              </div>
            </div>

            {/* Billing Period */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Billing Period</label>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <i className="fa fa-calendar-alt" style={{ color: teal, fontSize: "14px" }} aria-hidden />
                <input type="date" value={billingFrom} onChange={(e) => setBillingFrom(e.target.value)} style={inputStyle} />
                <span className="text-muted">-</span>
                <input type="date" value={billingTo} onChange={(e) => setBillingTo(e.target.value)} style={inputStyle} />
              </div>
            </div>

            {/* Tax Details */}
            <div className="mb-4">
              <label className="form-label mb-2 d-block" style={{ fontSize: "14px", color: "#334155" }}>Tax Details (GST Information)</label>
              <div className="row g-3">
                <div className="col-12 col-md-4">
                  <label className="form-label mb-1 small text-muted">CGST (%)</label>
                  <input type="text" value={cgstPct} onChange={(e) => setCgstPct(e.target.value)} style={inputStyle} placeholder="(₹) : 0" />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label mb-1 small text-muted">SGST (%)</label>
                  <input type="text" value={sgstPct} onChange={(e) => setSgstPct(e.target.value)} style={inputStyle} placeholder="(₹) : 0" />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label mb-1 small text-muted">IGST (%)</label>
                  <input type="text" value={igstPct} onChange={(e) => setIgstPct(e.target.value)} style={inputStyle} placeholder="(₹) : 0" />
                </div>
              </div>
            </div>

            {/* Bill Description */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Bill Description</label>
              <textarea value={billDescription} readOnly rows={3} style={{ ...inputStyle, background: "#f8fafc", resize: "vertical" }} />
            </div>

            {/* Signatory Name */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Signatory Name</label>
              <input type="text" value={signatoryName} onChange={(e) => setSignatoryName(e.target.value)} style={inputStyle} />
            </div>

            {/* Proceed */}
            <div className="text-center">
              <button
                type="button"
                className="border-0 rounded px-4 py-2"
                style={{ background: teal, color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer" }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
